import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, FabContainer, LoadingController, AlertController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import moment from 'moment'
import { SolicitudPage } from '../solicitud/solicitud';

/**
 * Generated class for the SolicitudesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-solicitudes',
  templateUrl: 'solicitudes.html',
})
export class SolicitudesPage {
  solicitudes: any = []
  vendedor: any
  vendedores: any = []
  loadModal: any
  buscado: any = false
  fecha: any = moment().format('YYYY-MM-DD')
  selectTitleVendedor: any = {
    title: 'Vendedores',
  }
  super: any = false
  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public http: HttpProvider,
    public navParams: NavParams,
    public modalSrv: ModalController
  ) {
  }

  ionViewDidLoad() {
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  ionViewDidEnter() {
    if(window.localStorage.getItem('super')){
      this.super = true
    }else{
      this.vendedor = window.localStorage.getItem('co_ven')
    }
    this.buscar()
  }

  irSolicitud(){
    this.navCtrl.push(SolicitudPage)
  }

  verSolicitud(item, fab: FabContainer) {
    fab.close()
    this.navCtrl.push(SolicitudPage, {value: JSON.stringify(item)})
  }

  editarSolicitud(item, fab: FabContainer) {
    fab.close()
    this.navCtrl.push(SolicitudPage, {value: JSON.stringify(item), edit: true})
  }

  buscar() {
    this.buscado = false
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      if (!this.super) {
        this.http.get(`solicitudes/ven/${this.vendedor.replace(/ /g,'')}?fecha=${this.fecha}`).subscribe(
          (res:any)=>{
            this.solicitudes = res
            if (this.solicitudes.length === 0) this.buscado = true 
            this.DesactivarLoading()
          },
          error=>{
            this.DesactivarLoading()
            this.buscado = true
            console.log(error)
          }
        )
      } else {
        let id = window.localStorage.getItem('id')
        this.http.get(`solicitudes/super/${id}?fecha=${this.fecha}&vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
          (res:any)=>{
            this.solicitudes = res
            if (this.solicitudes.length === 0) this.buscado = true 
            this.DesactivarLoading()
          },
          error=>{
            this.DesactivarLoading()
            this.buscado = true
            console.log(error)
          }
        )
      }
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/solicitudes/solicitudes.ts